var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequest1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact-info 1",
    clipPath: "url(#clip0_311_53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6827 1.29315V4.33733H19.7267L16.6827 1.29315Z",
    fill: "#343568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.1822 5.33843C15.9058 5.33843 15.6816 5.1143 15.6816 4.83784V1H8.50653C7.67845 1 7.00476 1.67369 7.00476 2.50177V8.09798C7.16969 8.08302 7.33658 8.07498 7.50535 8.07498C9.21162 8.07498 10.7391 8.8551 11.7499 10.0773H17.1834C17.4598 10.0773 17.684 10.3015 17.684 10.5779C17.684 10.8544 17.4598 11.0785 17.1834 11.0785H12.4094C12.7292 11.7026 12.9259 12.3824 12.9888 13.0809H17.1834C17.4598 13.0809 17.684 13.305 17.684 13.5815C17.684 13.8579 17.4598 14.082 17.1834 14.082H12.9888C12.8391 15.7353 11.9558 17.1799 10.6677 18.0868H18.5183C19.3464 18.0868 20.0201 17.4131 20.0201 16.585V5.33843H16.1822ZM17.1834 8.07498H9.84143C9.56497 8.07498 9.34084 7.85085 9.34084 7.57439C9.34084 7.29794 9.56497 7.07381 9.84143 7.07381H17.1834C17.4598 7.07381 17.684 7.29794 17.684 7.57439C17.684 7.85085 17.4598 8.07498 17.1834 8.07498Z",
    fill: "#343568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.50529 9.07623C5.02108 9.07623 3 11.0973 3 13.5815C3 16.0657 5.02108 18.0868 7.50529 18.0868C9.98951 18.0868 12.0106 16.0657 12.0106 13.5815C12.0106 11.0973 9.98951 9.07623 7.50529 9.07623ZM8.8402 14.0821H7.50529C7.22884 14.0821 7.00471 13.858 7.00471 13.5815V11.5792C7.00471 11.3027 7.22884 11.0786 7.50529 11.0786C7.78175 11.0786 8.00588 11.3027 8.00588 11.5792V13.0809H8.8402C9.11666 13.0809 9.34079 13.3051 9.34079 13.5815C9.34079 13.858 9.11666 14.0821 8.8402 14.0821Z",
    fill: "#343568"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_53"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest1);
export default __webpack_public_path__ + "static/media/request 1.1bd402b84fba3887cbdd69ff0d5be091.svg";
export { ForwardRef as ReactComponent };